// Create nav links with worksheet status
// Header grouped by Sample ID highlighted by search text tokens
// Optional Sub Header of Project Name and Code
export const worksheetNavLinks = (worksheets, searchText, includeSubHeader = false) => {
  if (!!worksheets && worksheets.length > 0)
    return worksheets.map((w, i, worksheets) => {
      /* Only show heading for first worksheet with that sample id */
      let heading = null;
      let subHeading = null;
      let sampleId =
        !!worksheets[i - 1] && w.Header.Sample.SampleId === worksheets[i - 1].Header.Sample.SampleId
          ? null
          : w.Header.Sample.SampleId;

      if (!!sampleId) {
        heading = {
          tokens: [],
        };
        if (!!searchText) {
          /* Split up sample id on search tokens so that tokens can be highlighted in UI*/
          let searchTokens = searchText.split(/[^0-9a-z]/gi);
          searchTokens.forEach((token) => {
            var re = new RegExp(token, 'gi');
            let tokenIndex = sampleId.search(re);
            if (tokenIndex >= 0) {
              heading.tokens.push({ text: sampleId.substring(0, tokenIndex), highlight: false });
              heading.tokens.push({ text: sampleId.substring(tokenIndex, tokenIndex + token.length), highlight: true });
              sampleId = sampleId.substring(tokenIndex + token.length);
            }
          });
        }
        heading.tokens.push({ text: sampleId, highlight: false });
        subHeading =
          includeSubHeader && w.Header.Project
            ? ' ' + w.Header.Project.Name + ' (' + w.Header.Project.Code + ')'
            : null;
      }

      return {
        uri: `/worksheets/${w.Id}`,
        text: w.Type.Caption,
        status: {
          IsOnSignedReport: w.Header.IsOnSignedReport,
          IsChecked: w.Header.IsChecked,
          IsComplete: w.Header.IsComplete,
          WorkProgress: w.Header.WorkProgress,
        },
        heading: heading,
        subHeading: subHeading,
      };
    });
  else return [];
};

/**
 * Enum to describe filter test status
 */
export const FilterTestStatus = {
  // WorksheetStatusFilter enum
  allStatuses: 'AllStatuses',
  checkedOrReported: 'CheckedOrReported',
  readyForChecking: 'ReadyForChecking',
  incomplete: 'Incomplete',
};
